import { NotificationType } from '../model';

export function getNotificationType(
  notificationValue: number,
): NotificationType {
  if (notificationValue < 60) {
    return NotificationType.minutes;
  }
  return notificationValue < 24 * 60
    ? NotificationType.hours
    : NotificationType.days;
}
